module.exports = __webpack_public_path__ + "img/icon-9.d83d62c9.png";